import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useCart } from '../contexts/CartContext'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'

const OrderInformations = () => {
  const { t } = useTranslation()
  const { cartItems, cartSummary } = useCart()

  const [billingInfo, setBillingInfo] = useState({})
  const [shippingInfo, setShippingInfo] = useState({})
  const [acceptCGV, setAcceptCGV] = useState(false)
  const [isOrderInformationsReady, setIsOrderInformationsReady] =
    useState(false)

  const requiresShipping = cartSummary?.shippingCost > 0

  useEffect(() => {
    const billingComplete = billingInfo.name && billingInfo.address
    const shippingComplete =
      !requiresShipping || (shippingInfo.name && shippingInfo.address)
    setIsOrderInformationsReady(
      billingComplete && shippingComplete && acceptCGV,
    )
  }, [billingInfo, shippingInfo, acceptCGV, requiresShipping])

  const handleProceedToPayment = async () => {
    try {
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cart: cartItems }), // ou les infos utiles
      })
      const data = await response.json()
      if (data.url) {
        window.location.href = data.url
      } else {
        alert('Une erreur est survenue lors de la redirection vers Stripe.')
      }
    } catch (error) {
      console.error(error)
      alert('Erreur lors de la communication avec Stripe.')
    }
  }

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t('ORDER_INFORMATIONS')}
        description=""
      />

      <div className="container p-4">
        <section>
          <h2>{t('BILLING_INFORMATIONS')}</h2>
          <input
            type="text"
            placeholder={t('NAME')}
            className="form-control mb-2"
            onChange={(e) =>
              setBillingInfo({ ...billingInfo, name: e.target.value })
            }
          />
          <input
            type="text"
            placeholder={t('ADDRESS')}
            className="form-control mb-3"
            onChange={(e) =>
              setBillingInfo({ ...billingInfo, address: e.target.value })
            }
          />
        </section>

        {requiresShipping && (
          <section>
            <h2>{t('SHIPPING_INFORMATIONS')}</h2>
            <input
              type="text"
              placeholder={t('NAME')}
              className="form-control mb-2"
              onChange={(e) =>
                setShippingInfo({ ...shippingInfo, name: e.target.value })
              }
            />
            <input
              type="text"
              placeholder={t('ADDRESS')}
              className="form-control mb-3"
              onChange={(e) =>
                setShippingInfo({ ...shippingInfo, address: e.target.value })
              }
            />
          </section>
        )}

        <section className="my-4">
          <h4>{t('ORDER_SUMMARY')}</h4>
          <p>
            {t('ITEMS_PRICE')}: {cartSummary?.itemsPrice / 100} €
          </p>
          <p>
            {t('SHIPPING_COST')}: {cartSummary?.shippingCost / 100} €
          </p>
          <p>
            <strong>
              {t('TOTAL_PRICE')}: {cartSummary?.totalPrice / 100} €
            </strong>
          </p>
        </section>

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="acceptCGV"
            onChange={(e) => setAcceptCGV(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="acceptCGV">
            {t('I_ACCEPT_TERMS_AND_CONDITIONS')}
          </label>
        </div>

        {!isOrderInformationsReady && (
          <div className="alert alert-warning text-center">
            {t('PLEASE_FILL_ALL_INFOS_AND_ACCEPT_TERMS')}
          </div>
        )}

        <div className="text-center">
          <button
            className="btn btn-primary"
            disabled={!isOrderInformationsReady}
            onClick={handleProceedToPayment}
          >
            {t('PROCEED_TO_PAYMENT')}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default OrderInformations
